"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLight = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("primereact/utils");
const tooltip_1 = require("primereact/tooltip");
const CautionSign_1 = require("./CautionSign");
const StatusLight = (props) => {
    const [horizontal, setHorizontal] = (0, react_1.useState)(props.horizontal);
    const [backgroundColor, setBackgroundColor] = (0, react_1.useState)('black');
    const [style, setStyle] = (0, react_1.useState)({
        wrapper: {
            zIndex: 1,
            position: 'relative'
        },
        statusLight: {
            position: 'relative',
            borderRadius: '50px',
            background: 'linear-gradient(0deg, rgba(145, 145, 145, 1) 0%, rgba(233, 233, 233, 1) 100%)',
            padding: '3px',
            maxWidth: '80px',
            display: 'inline-block',
        },
        scale: {
            transform: props.scale ? `scale(${props.scale})` : undefined
        },
        signal: {
            position: 'relative',
            background: 'radial-gradient(circle, rgba(255,255,255,1) 15%, rgba(200,200,200,1) 50%, rgba(150,150,150,1) 100%)',
            width: '14px',
            height: '14px',
            boxShadow: 'inset 0 0 2px #00000044',
            borderRadius: '50px',
            // border: 1px solid black;
            margin: '2px',
            // zIndex: '10'
        },
        overlay: {
            position: 'absolute',
            top: '0',
            left: '0',
            opacity: '0.5',
            height: '100%',
            width: '100%',
            margin: '0',
            zIndex: 10,
        },
        active: {
            background: 'radial-gradient(circle, rgba(255,255,255,1) 10%, rgba(180,180,180,1) 70%, rgba(0,0,0,1) 100%)',
            zIndex: '10'
        },
    });
    (0, react_1.useEffect)(() => {
        setBackgroundColor(props.inactive ? 'white' : 'black');
    }, [props.inactive]);
    const isActive = (nr) => {
        let result = false;
        switch (props.value) {
            case 1:
                result = nr === 0;
                break;
            case 2:
                result = nr === 1;
                break;
            case 3:
                result = nr === 2;
                break;
        }
        return result;
    };
    return ((0, jsx_runtime_1.jsxs)("i", Object.assign({ className: (0, utils_1.classNames)(props.horizontal ? 'flex' : '', 'status-light'), style: style.wrapper, "data-pr-tooltip": props.info, "data-pr-position": "right" }, { children: [(0, jsx_runtime_1.jsxs)("i", Object.assign({ id: props.id, className: horizontal ? 'flex' : '', style: Object.assign(Object.assign(Object.assign({}, style.statusLight), style.scale), (horizontal ? { maxWidth: '81px' } : { maxWidth: '30px' })) }, { children: [(0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign(Object.assign(Object.assign({}, style.statusLight), style.overlay), (backgroundColor ? { background: backgroundColor } : {})), (horizontal ? { maxWidth: '81px' } : { maxWidth: '23px' })) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: Object.assign(Object.assign({}, style.signal), (isActive(0) ? style.active : {})) }, { children: (0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign(Object.assign({}, style.signal), style.overlay), (isActive(0) ? {
                                background: 'red',
                                opacity: props.light ? '0.4' : '1'
                            } : {})) }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: Object.assign(Object.assign({}, style.signal), (isActive(1) ? style.active : {})) }, { children: (0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign(Object.assign({}, style.signal), style.overlay), (isActive(1) ? {
                                background: 'yellow',
                                opacity: props.light ? '0.4' : '1'
                            } : {})) }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: Object.assign(Object.assign({}, style.signal), (isActive(2) ? style.active : {})) }, { children: (0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign(Object.assign({}, style.signal), style.overlay), (isActive(2) ? {
                                background: 'chartreuse',
                                opacity: props.light ? '0.4' : '1'
                            } : {})) }) })), (0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: '#' + props.id })] })), props.caution &&
                (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'm-auto' }, { children: (0, jsx_runtime_1.jsx)(CautionSign_1.CautionSign, { id: 'cautionsign-' + props.id, info: 'Test Caution' }) }))] })));
};
exports.StatusLight = StatusLight;
